import * as React from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import { styles } from 'components/Table/Table.styles';
import TableToolbar from 'components/TableToolbar';
import Table from 'components/Table/Table';
import { TableConfigEntry } from 'utils/tableConfig';
import ConnectedTableFilters from 'components/Table/ConnectedTableFilters';
import ConnectedButton from 'components/Button/ConnectedButton';
import InternalLink from 'components/Link/InternalLink';
import { useSongGenres } from 'novaApi/hooks/song_genre';

const useStyles = makeStyles(styles);

const tableConfig: TableConfigEntry<Nl.Api.SongGenre> = {
  columnData: [
    { id: 'name', label: 'Name', isSortable: true },
    {
      id: 'parent',
      label: 'Parent Genre',
      render: ({ parent }) => parent?.name || '-',
    },
    {
      id: 'songs',
      label: 'Songs',
      render: ({ song_count, uuid }) =>
        song_count < 1 ? (
          song_count
        ) : (
          <InternalLink
            color='inherit'
            to={{
              type: 'route/SONGS',
              payload: { query: { genre_uuid: uuid } },
            }}
          >
            {song_count}
          </InternalLink>
        ),
    },
  ],
};

export default function SongGenrePage() {
  const data = useSongGenres();
  const classes = useStyles({});

  return (
    <Paper elevation={1} className={classes.root}>
      <TableToolbar
        title='Song Genres'
        search={
          <ConnectedTableFilters
            filters={[
              {
                type: 'search',
                size: 6,
                label: 'Search by name',
                queryFilterKey: 'name',
                e2e: 'name',
              },
            ]}
          />
        }
        actions={
          <ConnectedButton
            icon='add'
            fab
            route='route/SONG_GENRE_CREATE'
            label='Create song genres'
            permission='CAN_CREATE_SONG_GENRES'
          />
        }
      />
      <Table
        config={tableConfig}
        data={data?.song_genres ?? []}
        isLoaded={!!data}
        paginationData={data}
      />
    </Paper>
  );
}
